export const createPdf = 'api/prequalify/rest/create-pdf';
export const dealerLeadUrl = 'api/prequalify/rest/dealer-lead';
export const searchDealerEndpoint = 'api/prequalify/rest/dealer-search';
export const addressValidationApi = 'api/prequalify/rest/standardize-address';
export const addressTypeAheadApi = 'api/prequalify/rest/addressLookup';
export const maintenanceStatusApi = 'api/prequalify/rest/maintenanceStatus';
export const configApi = 'api/prequalify/rest/config';
export const logServiceEndpoint = 'api/prequalify/rest/log';
